import { useCallback, useRef } from "react";
import useLocalStorage from "./LocalStorage";
// import { useUserProperty, useCustomEvent } from "./Analytics";

export default function useProfile() {
    const deprecatedProfile = useLocalStorage('profile', {
        avatar: undefined, name: undefined,
    })[0];
    const [profileName, setProfileName] = useLocalStorage('profileName', deprecatedProfile.name);
    const [profileAvatar, setProfileAvatar] = useLocalStorage('profileAvatar', deprecatedProfile.avatar);

    const sendEventRef = useRef(undefined);
    const setSendEvent = useCallback((f) => {
        sendEventRef.current = f;
    }, []);

    // const updateProfile = useCallback((name, avatar) => {
    //     setProfileName(name)
    //     setProfileAvatar(avatar)
    // }, [setProfileName, setProfileAvatar]);

    const updateProfileName = setProfileName
    const updateProfileAvatar = setProfileAvatar

    const sendChangeProfile = useCallback((profileObject) => {
        if (sendEventRef.current) {
            sendEventRef.current("change_profile", profileObject)
        } else {
            console.log("I wanted to send 'change_profile' but there is no 'sendEvent'/connection function here", sendEventRef.current);
        }
    }, [sendEventRef]);


    return {
        updateProfileName, updateProfileAvatar,
        name: profileName, avatar: profileAvatar,
        setSendEvent, sendChangeProfile,
    }
}
